import React, { useState } from "react";
import emailjs from "emailjs-com";

function Contact({ className }) {
    const [formState, setFormState] = useState({
        name: "",
        email: "",
        subject: "",
        message: "",
    });

    const [responseMessage, setResponseMessage] = useState("");

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormState({ ...formState, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Replace with your EmailJS service ID, template ID, and user ID
        const serviceID = "your_service_id";
        const templateID = "your_template_id";
        const userID = "your_user_id";

        emailjs
            .send(serviceID, templateID, formState, userID)
            .then((response) => {
                console.log("SUCCESS!", response.status, response.text);
                setResponseMessage("Your message has been sent successfully!");
                setFormState({ name: "", email: "", subject: "", message: "" });
            })
            .catch((error) => {
                console.error("FAILED...", error);
                setResponseMessage("Failed to send your message. Please try again.");
            });
    };

    return (
        <>
            {/* Contact area Start */}
            <section id="contact" className={`rts-contact-area bg-two ${className}`}>
                <div className="container">
                    <div className="section-title-area2">
                        <p className="sub-title wow fadeInUp" data-wow-delay=".2s" data-wow-duration="2s">
                            Contact us
                        </p>
                        <h2 className="section-title wow fadeInUp" data-wow-delay=".5s" data-wow-duration="2s">
                            Get in Touch with Us!
                        </h2>
                        <p className="desc wow fadeInUp" data-wow-delay=".8s" data-wow-duration="2s">
                            "Have questions, feedback, or need assistance? We’re here to help!
                            Reach <br /> out to our team, and we’ll get back to you as soon as
                            possible.
                        </p>
                    </div>
                    <div
                        className="form-inner mt--40 wow fadeInUp"
                        data-wow-delay="1.2s"
                        data-wow-duration="2s"
                    >
                        <form onSubmit={handleSubmit}>
                            <div className="form-content-box">
                                <div className="form-group d-flex">
                                    <div className="input-wrapper">
                                        <input
                                            id="name"
                                            name="name"
                                            placeholder="Enter Your Name"
                                            type="text"
                                            value={formState.name}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="input-wrapper">
                                        <input
                                            id="email"
                                            name="email"
                                            placeholder="Enter Your Email Address"
                                            type="email"
                                            value={formState.email}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="input-wrapper">
                                        <input
                                            id="subject"
                                            name="subject"
                                            placeholder="Subject"
                                            type="text"
                                            value={formState.subject}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="input-wrapper">
                                        <textarea
                                            name="message"
                                            id="message"
                                            placeholder="Type Your Message"
                                            value={formState.message}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="button with-after2">
                                        <button className="rts-btn btn-primary" type="submit">
                                            Send Message
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                        {responseMessage && <p className="response-message">{responseMessage}</p>}
                    </div>
                </div>
                <div className="shape-area">
                    <img src="assets/images/roadmap/shape-01.svg" alt="" />
                    <img src="assets/images/roadmap/shape-02.svg" alt="" />
                    <img src="assets/images/roadmap/shape-03.svg" alt="" />
                </div>
            </section>
            {/* Contact area End */}
        </>
    );
}

export default Contact;
